import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IntersectionObserver from '@researchgate/react-intersection-observer';
import { connect } from 'react-redux';

import styles from 'src/components/RecommendationsHeaderContainer.scss';
import { getCounter } from 'src/redux/actions/counter';


const RecommendationsHeaderContainer = ({ dispatch, counter, isLoggedIn }) => {
  const titleText = 'Wybrane dla Ciebie';
  const counterText = counter ? `(spośród ${counter.toLocaleString('ru-Ru')} ofert)` : '';

  const counterClassList = classNames(
    styles.header__secondary,

    /*
     * we hide counter, because fragment-slider already has counter.
     * It might lead to two different values. Confuse user.
     */
    { [styles['header__secondary--not-logged-in']]: !isLoggedIn }
  );

  const loadCounter = useCallback(({ intersectionRatio }, unobserve) => {
    if (intersectionRatio) {
      dispatch(getCounter());
      unobserve();
    }
  }, [dispatch]);

  return (
    <div styleName="header">
      <h2 styleName="header__primary">
        {titleText}
      </h2>

      <IntersectionObserver onChange={ loadCounter }>
        <span className={ counterClassList } data-test="text-offersCounter">
          { counterText }
        </span>
      </IntersectionObserver>
    </div>
  );
};

RecommendationsHeaderContainer.propTypes = {
  counter: PropTypes.number,
  dispatch: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired
};

RecommendationsHeaderContainer.defaultProps = {
  counter: null
};

const mapStateToProperties = state => ({
  counter: state.counterReducer.counter,
  isLoggedIn: Boolean(state.credentialsReducer.mpUserId)
});

export default memo(connect(mapStateToProperties)(RecommendationsHeaderContainer));
